<div class="addendum-message">
  <div class="message-content">
    {{ extMessage }}
  </div>
</div>
